// oxlint-disable-next-line constellation/no-styled-factory -- this module's entire purpose is Panda styled() wrapper components; not a lint-opt-in migration
import { styled } from '@/styled-system/jsx';
import { List } from '@zillow/constellation-10';

// oxlint-disable-next-line constellation/no-styled-factory -- this module's entire purpose is Panda styled() wrapper components; not a lint-opt-in migration
export const StyledListItem = styled(List.Item, {
  base: {
    padding: '0 !important',
  },
});
